var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "配置属性",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "d-flex a-center nameWrap" }, [
            _vm._v(
              " 当前品类 " +
                _vm._s(
                  _vm.info && _vm.info.name
                    ? `${_vm.info.first_category.name}-${_vm.info.name}`
                    : ""
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            { staticClass: "contentWrap" },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.field_keys,
                    callback: function ($$v) {
                      _vm.field_keys = $$v
                    },
                    expression: "field_keys",
                  },
                },
                _vm._l(_vm.checkData, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.field_key, attrs: { label: item.field_key } },
                    [_vm._v(_vm._s(item.field_key))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.onHandleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }